import { render, staticRenderFns } from "./off.vue?vue&type=template&id=5da5ef21&scoped=true&"
import script from "./off.vue?vue&type=script&lang=js&"
export * from "./off.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da5ef21",
  null
  
)

export default component.exports